import React from "react"
import FaIcon from "components/fa_icon"

function Learnables({learnable}) {
  return (
    <div className="learnable-level">
      <span className="icon">
        <FaIcon name={"fa-donut"} text_aligned={true}/>
      </span>
      <span className="learnable-title">
        {learnable.name}
      </span>
    </div>
  )
}

export default Learnables
